{
  "Could not open checkout": "決済ページを開けませんでした",
  "Please try again, or open evt.live in your browser to complete the purchase.": "もう一度お試しいただくか、ブラウザでevt.liveを開いて購入を完了してください。",
  "{price} One Time": "{price}（買い切り）",
  "{count} extra day: {price} / day": {
    "other": "追加{count}日：1日あたり{price}"
  },
  "{days}-Day Event: {price} / day": "{days}日間のイベント：1日あたり{price}",
  "Purchase needs attention": "購入について確認が必要です",
  "Your payment was received, but we could not match it to an event. Please contact support and we will unlock it for you.": "お支払いは受け付けましたが、イベントと紐付けることができませんでした。サポートまでご連絡ください。こちらでアンロックいたします。",
  "Payment received": "お支払いを受け付けました",
  "Your payment went through, but we couldn't activate your event yet. Please don't purchase again. Contact support and we'll activate it for you.": "お支払いは完了しましたが、まだイベントを有効にできていません。再度購入しないでください。サポートまでご連絡いただければ、こちらで有効にいたします。",
  "Your payment went through, but we couldn't add your credits yet. Please don't purchase again. Contact support and we'll add them for you.": "お支払いは完了しましたが、まだクレジットを追加できていません。再度購入しないでください。サポートまでご連絡いただければ、こちらで追加いたします。",
  "Not bought": "購入されませんでした",
  "Still loading prices": "価格を読み込んでいます",
  "Please wait a moment while we load the latest store prices.": "最新のストア価格を読み込んでいます。しばらくお待ちください。",
  "Prices unavailable": "価格を取得できません",
  "We could not load the latest price. Check your connection and try again.": "最新の価格を読み込めませんでした。接続を確認して、もう一度お試しください。",
  "Billed monthly": "毎月請求",
  "/mo": "/月",
  "Annual": "年額",
  "Billed annually": "毎年請求",
  "/yr": "/年",
  "Unlock {count}-day event": "{count}日間のイベントをアンロック",
  "Unlock single event": "イベントを1件アンロック",
  "Single credit": "1クレジット",
  "Use {count} credit to unlock this event now": {
    "other": "{count}クレジットを使って、今すぐこのイベントをアンロック"
  },
  "One event": "イベント1件",
  "{count} event": {
    "other": "イベント{count}件"
  },
  "Save {amount}": "{amount}お得",
  "Subscribe": "登録する",
  "Unlock with {count} Credit": {
    "other": "{count}クレジットでアンロック"
  },
  "Buy Single Credit": "1クレジットを購入",
  "Buy {count} Credits & Unlock Event": "{count}クレジットを購入してアンロック",
  "Buy {count} Event Credits": "{count}クレジットを購入",
  "{plan}: loading": "{plan}：読み込み中",
  "Unlimited storage while you're subscribed": "サブスクリプション期間中は保存期間が無制限",
  "Unlimited storage as long as you make one pack purchase per year": "年に1回パックを購入すれば保存期間が無制限",
  "Credits": "クレジット",
  "You see grandfathered (legacy) pricing. Prices for new clients may vary.": "以前の料金（旧価格）が適用されています。新規のお客様の価格とは異なる場合があります。",
  "{price} per day": "1日あたり{price}",
  "{price} per event": "1イベントあたり{price}",
  "Every Event Includes": "すべてのイベントに含まれるもの",
  "Unlimited viewers": "視聴者数無制限",
  "Full-day HD broadcasting": "終日HD配信",
  "White-labeling and website embedding": "ホワイトラベルとウェブサイトへの埋め込み",
  "Unlimited email and chat support": "メールとチャットによるサポートが無制限",
  "Professional Analytics": "プロ向けの分析",
  "5000 viewer-hours per event (soft limit)": "1イベントあたり延べ視聴時間5000時間（目安）",
  "Unlimited pay-per-view viewer-hours ($1.50 per ticket sold)": "ペイパービューの延べ視聴時間は無制限（チケット1枚の販売につき$1.50）",
  "Loading Prices": "価格を読み込んでいます",
  "Cancel anytime": "いつでも解約可能",
  "Event credits do not expire": "イベントクレジットに有効期限はありません",
  "Manage it in your Profile": "プロフィールで管理できます",
  "Reschedule or cancel free": "日程変更・キャンセルは無料",
  "{price} annually": "年額{price}",
  "Subscribe to EventLive Unlimited": "EventLiveの無制限プランに登録",
  "Create Unlimited Events": "イベントを無制限に作成",
  "Unlimited Storage for all your events": "すべてのイベントの保存期間が無制限",
  "Per-event white-labeling": "イベントごとのホワイトラベル",
  "Embed on your website": "ウェブサイトに埋め込む",
  "Advanced Event Analytics": "高度なイベント分析",
  "Pay-per-view ticketing: US $1.50 per ticket": "ペイパービューのチケット販売：チケット1枚につきUS $1.50",
  "Non pay-per-view events have a soft limit of 5000 viewer-hours (15TB bandwidth). For larger events, additional viewer-hours can be purchased at $20 per 1000 (3TB bandwidth).": "ペイパービュー以外のイベントには、延べ視聴時間5000時間（帯域幅15TB）の目安上限があります。大規模なイベントでは、延べ視聴時間を1000時間（帯域幅3TB）あたり$20で追加購入できます。",
  "Plan": "プラン",
  "Price": "価格",
  "Billing Cycle": "請求サイクル",
  "You Save": "割引額",
  "GET": "購入",
  "{count} camera angles on one link": "{count}台のカメラの映像を1つのリンクで",
  "Guests switch between the cameras in the player.": "ゲストはプレーヤー上でカメラを切り替えられます。",
  "Go live on {date}": "{date}にライブ配信",
  "Your event link is ready the moment you unlock it.": "アンロックした瞬間から、イベントリンクを使えます。",
  "Go Live for {count} days": "{count}日間ライブ配信",
  "All-Day HD broadcasting": "終日HD配信",
  "Pause and resume stream to the same link across all event days.": "イベントの全日程を通じて、同じリンクで配信を一時停止・再開できます。",
  "Pause and Resume stream to the same link. Immersive audience experience.": "同じリンクで配信を一時停止・再開できます。臨場感あふれる視聴体験を届けましょう。",
  "Replay & download for {length}": "{length}間の録画視聴とダウンロード",
  "Replay & download": "録画とダウンロード",
  "Kept online for {length}. You can change it below.": "{length}間公開されます。下で変更できます。",
  "Kept online for the time you choose below": "下で選択した期間、公開されます",
  "Unlimited guests": "ゲスト数無制限",
  "Bring in as many viewers as you like, without any restrictions.": "視聴者数に制限はありません。何人でも招待できます。",
  "Reminders for guests": "ゲストへのリマインダー",
  "Timely reminders, so no one misses out.": "タイミングよくリマインダーが届くので、見逃す人がいません。",
  "1 month": "1か月",
  "1 year": "1年",
  "A year of memories": "1年分の思い出",
  "Recommended": "おすすめ",
  "10 years": "10年",
  "A decade of memories": "10年分の思い出",
  "Best value": "最もお得",
  "Best $ spent on a Bar Mitzvah! It was such a relief to be able to send out a custom link in an invitation and not have to worry about people connecting via an app or having to sign in somewhere.": "バル・ミツワーで一番価値のあるお金の使い方でした！招待状にオリジナルのリンクを載せるだけで、アプリでの接続やどこかへのログインを心配しなくてよかったので、本当に安心しました。",
  "{author} review on the App Store": "{author}（App Storeのレビュー）",
  "Just started using EventLive about a week ago and it has been incredible. It's easy to use, full of features, and very affordable.": "1週間ほど前にEventLiveを使い始めましたが、本当に素晴らしいです。使いやすく、機能が充実していて、とても手頃です。",
  "So simple and easy to use that I would recommend it for any of your live event needs. Setup and testing makes it easy to know what you need to do on the day.": "とてもシンプルで使いやすいので、どんなライブイベントにもおすすめです。事前の設定とテストのおかげで、当日に何をすればいいかがよくわかります。",
  "{price} a day": "1日{price}",
  "DATE PASSED – CHANGE IT FOR FREE": "日付が過ぎています – 無料で変更できます",
  "STARTS TODAY": "本日開始",
  "LIVE IN {count} WEEK": {
    "other": "{count}週間後にライブ配信"
  },
  "LIVE IN {count} DAY": {
    "other": "{count}日後にライブ配信"
  },
  "LIVE IN {count} HOUR": {
    "other": "{count}時間後にライブ配信"
  },
  "LIVE IN {minutes} MIN": "{minutes}分後にライブ配信",
  "GO LIVE NOW": "今すぐライブ配信",
  "1 month of replay": "動画の公開期間：1か月",
  "Replay deleted {date}": "{date}に録画を削除",
  "Until {date}": "{date}まで公開",
  "More angles on the same link": "同じリンクで、より多くのアングルを",
  "Guests switch between the cameras in the player. Nothing new to send.": "ゲストはプレーヤー上でカメラを切り替えられます。新たに送るものはありません。",
  "One guestbook for every angle": "すべてのアングルで1つのゲストブック",
  "Messages stay together, whichever camera guests watch.": "ゲストがどのカメラを視聴していても、メッセージは1か所にまとまります。",
  "Replay & download, like your main camera": "メインカメラと同じく録画とダウンロードに対応",
  "{replay}. Each camera keeps its own recording.": "{replay}。カメラごとに録画が保存されます。",
  "Stream from any phone": "どのスマートフォンからでも配信",
  "Send each camera's link or QR code to whoever holds it.": "各カメラのリンクまたはQRコードを、そのカメラを担当する人に送ってください。",
  "One-time · {count} cameras": "買い切り・カメラ{count}台",
  "One-time · {count} days": "買い切り・{count}日間",
  "One-time": "買い切り",
  "Unlock {name}": "{name}をアンロック",
  "Unlock {count} cameras": "カメラ{count}台をアンロック",
  "Extra cameras still locked": "追加カメラはまだロックされています",
  "Your event is unlocked. {cameras} is still locked: you can unlock it from the event at any time.": {
    "other": "イベントはアンロックされました。{cameras}はまだロックされています。イベントからいつでもアンロックできます。"
  },
  "Opening plans...": "プランを開いています…",
  "Stream your event to <em>everyone</em> who matters.": "大切な<em>すべての人</em>に、イベントを届けましょう。",
  "FAQs": "よくある質問",
  "<b>12,400+</b> events streamed this year": "今年<b>12,400件以上</b>のイベントを配信",
  "Includes an extra camera at {price}, kept as long as your event.": {
    "other": "追加カメラ{count}台（1台あたり{price}）が含まれます。イベントと同じ期間保存されます。"
  },
  "Includes an extra camera, kept as long as your event.": {
    "other": "追加カメラ{count}台が含まれます。イベントと同じ期間保存されます。"
  },
  "Extra cameras, {price} each": "追加カメラ（1台あたり{price}）",
  "Extra cameras": "追加カメラ",
  "{count} cameras": "カメラ{count}台",
  "Replay until {date}": "{date}まで動画を公開",
  "How long to keep the replay?": "動画をどのくらいの期間公開しますか？",
  "One-time payment": "買い切り",
  "Replay for {length}": "動画の公開期間：{length}",
  "SAVE {percent}%": "{percent}%お得",
  "{payment} · Money-back guarantee": "{payment}・返金保証",
  "100% money-back guarantee": "100%返金保証",
  "Replay online for {length}. Change how long": "動画の公開期間：{length}。期間を変更",
  "Replay online for <b>{length}</b>": "動画の公開期間：<b>{length}</b>",
  "Keep the replay online for": "動画の公開期間",
  "You can keep it online longer later, from the event page.": "公開期間は、後からイベントページで延長できます。",
  "Does it work in any country?": "どの国でも使えますか？",
  "Yes, EventLive works globally. Viewers can join from any country.": "はい、EventLiveは世界中で利用できます。視聴者はどの国からでも参加できます。",
  "Will I have a recording of my event?": "イベントの録画は残りますか？",
  "Yes, the app saves a 1080p full quality recording to your device's photo gallery as you stream. It also saves the recording on our servers for on-demand viewing and downloading after the event.": "はい。配信中、アプリは1080pの最高画質の録画をデバイスの写真ライブラリに保存します。録画は当社のサーバーにも保存され、イベント後にオンデマンドで視聴・ダウンロードできます。",
  "Can I buy now and stream from a different device later?": "今購入して、後で別のデバイスから配信できますか？",
  "Yes, you can sign in to the EventLive app on any device with your email and password. You can then stream live on the day of the event.": "はい。どのデバイスでも、メールアドレスとパスワードでEventLiveアプリにログインできます。イベント当日は、そのデバイスからライブ配信できます。",
  "When should I invite my guests?": "ゲストはいつ招待すればよいですか？",
  "Invite guests now so they are notified ahead of your event. They will also be notified when you go live, so it won't distract from your day.": "今すぐゲストを招待しておけば、イベントの前に通知が届きます。ライブ配信を開始したときにも自動で通知されるので、当日の進行の妨げになりません。",
  "Can I pause and resume streaming?": "配信を一時停止して再開できますか？",
  "Yes, you can pause and resume streaming as often as needed. Cover ceremonies, speeches, receptions, etc. Guests will be automatically notified when you resume streaming. The videos will be merged into one recording.": "はい、配信は何度でも一時停止・再開できます。挙式、スピーチ、披露宴などをそれぞれ配信できます。配信を再開すると、ゲストに自動で通知されます。動画は1つの録画にまとめられます。",
  "Can I stream over 4G/5G or WiFi?": "4G/5GやWi-Fiで配信できますか？",
  "You can use either mobile data or WiFi to stream. Do a free test to see which internet connection works best at your location.": "モバイルデータ通信とWi-Fiのどちらでも配信できます。無料テストで、会場ではどのインターネット接続が最適かを確認しましょう。",
  "How much data does the app use?": "アプリのデータ使用量はどのくらいですか？",
  "The app uses about 1 GB of data per hour of streaming.": "配信1時間あたり約1GBのデータを使用します。",
  "What internet speed is recommended for streaming?": "配信に推奨されるインターネット速度は？",
  "A consistent minimum upload speed of 10 Mbps is recommended. The app adapts streaming quality if the connection becomes too slow or inconsistent.": "安定して10Mbps以上のアップロード速度があることを推奨します。接続が遅くなったり不安定になったりした場合は、アプリが配信の画質を自動で調整します。",
  "Can I reschedule or cancel an event?": "イベントの日程変更やキャンセルはできますか？",
  "Yes, you can reschedule for free or cancel and keep your payment for a future event.": "はい、日程変更は無料です。キャンセルした場合は、お支払いを今後のイベントに使えます。",
  "How long can guests access the event recording after it ends?": "イベント終了後、ゲストはいつまで録画を視聴できますか？",
  "Guests can watch the replay for the time you choose: 1 month, 1 year or 10 years. You can extend it later.": "ゲストは、選択した期間（1か月、1年、10年）録画を視聴できます。期間は後から延長できます。",
  "Do I need to mute guests?": "ゲストをミュートする必要はありますか？",
  "No, it is a one-way stream so guests cannot see or hear each other. They can leave guestbook messages, participate in live chat, etc.": "いいえ。一方向の配信なので、ゲスト同士がお互いを見たり聞いたりすることはありません。ゲストはゲストブックへのメッセージやライブチャットへの参加などができます。",
  "Can I see who joined the stream?": "配信に参加した人を確認できますか？",
  "Yes, you can view the list of guests who joined, were invited by email, signed the guestbook, subscribed for notifications, etc. You can also require guests to provide their name and email to view the complete guest list if desired.": "はい。参加したゲスト、メールで招待したゲスト、ゲストブックに記帳したゲスト、通知を申し込んだゲストなどのリストを確認できます。必要に応じて、ゲストに名前とメールアドレスの入力を求めれば、完全なゲストリストを作成できます。",
  "Can I stream from a GoPro, camera, laptop?": "GoPro、カメラ、ノートパソコンから配信できますか？",
  "Yes, you can use third party software like OBS or Vmix or hardware encoders. EventLive provides streaming details like server URL and stream key for use with these. See our help articles for setup instructions. We recommend using our app when possible for ease of use. You can switch to the app if issues arise with third party software/hardware.": "はい。OBSやvMixなどのサードパーティ製ソフトウェアや、ハードウェアエンコーダーを使用できます。EventLiveでは、これらで使用するサーバーURLやストリームキーなどの配信情報を提供しています。設定手順はヘルプ記事をご覧ください。使いやすさの面から、可能な限り当社のアプリのご利用をおすすめします。サードパーティ製のソフトウェアやハードウェアで問題が発生した場合は、アプリに切り替えることができます。",
  "Can I print my guestbook?": "ゲストブックを印刷できますか？",
  "Yes, you can export your guestbook (including pictures) as a formatted PDF to print. This option is available on your download page.": "はい。ゲストブック（写真を含む）を、印刷用に整えたPDFとしてエクスポートできます。このオプションはダウンロードページにあります。",
  "Can I embed the stream elsewhere?": "配信を他のサイトに埋め込めますか？",
  "Yes, we provide embed codes to customize and embed just the video or video plus guestbook on other sites.": "はい。動画のみ、または動画とゲストブックを他のサイトに埋め込める、カスタマイズ可能な埋め込みコードを提供しています。",
  "Can I add links or files to my event page?": "イベントページにリンクやファイルを追加できますか？",
  "Yes, you can add unlimited links and upload files to your event page.": "はい。イベントページには、リンクを無制限に追加したり、ファイルをアップロードしたりできます。",
  "Can I customize my event page?": "イベントページをカスタマイズできますか？",
  "Yes, you can upload images, slideshows, add welcome messages, links, documents, etc. to personalize it.": "はい。画像やスライドショーのアップロード、ウェルカムメッセージ、リンク、ドキュメントの追加などで、自由にカスタマイズできます。",
  "Can I password protect my event page?": "イベントページをパスワードで保護できますか？",
  "Yes, although pages are private by default.": "はい。なお、ページは初期設定で非公開になっています。",
  "What if someone misses the live event?": "ライブ配信を見逃した人はどうなりますか？",
  "Guests can watch the recording from the beginning anytime after joining. Live streams will take them directly to the current live point.": "ゲストは参加後いつでも、録画を最初から視聴できます。ライブ配信中に参加した場合は、現在の配信位置から視聴が始まります。",
  "What equipment do I need?": "どのような機材が必要ですか？",
  "Just an Android/iOS device (smartphone/tablet). We recommend a tripod for stability. A wireless microphone can also improve sound quality.": "Android/iOSのデバイス（スマートフォン・タブレット）があれば大丈夫です。安定させるために三脚の使用をおすすめします。ワイヤレスマイクを使うと、音質も向上します。"
}
